import { createSelector } from 'reselect';
import MessageCapabilityOverviewColumns from '../../containers/MessageCapabilityOverviewColumns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.MESSAGE_CAPABILITY_OVERVIEW.metadata.generatedOnDateTime;

export const getIsLoading = state => state.reporting.MESSAGE_CAPABILITY_OVERVIEW.isLoading;

export const getData = ReportDefinitions.MESSAGE_CAPABILITY_OVERVIEW.getDataFunction();

export const getRequestParams = state =>
  state.reporting.MESSAGE_CAPABILITY_OVERVIEW.requestParams;

export const getColumns = createSelector(
  getData,
  getRequestParams,
  MessageCapabilityOverviewColumns,
);
